import { UsersRound } from '@orgus/ui/icons';
import { TeamsView } from '../../teams/TeamsView.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'teams',
  title: 'Teams and workspaces',
  description: 'Your organisation, workspaces, teams and what reaches you.',
  order: 12,
  group: 'workspace',
  keywords: ['organisation', 'organization', 'workspaces', 'teams', 'mentions'],
  icon: UsersRound,
  Component: TeamsView,
  needs: { module: 'teams', feature: 'Teams', plural: true, instead: 'Members and their roles are in Settings, Members.' },
};
export default section;
